import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import IndexPage from './views/Index.vue'

Vue.use(Router)

// lazy-loaded
function loadView(path) {
	return () =>
		import(/* webpackChunkName: "view-[request]" */ `${path}`)
}


export default new Router({
	mode: process.env.NODE_ENV == 'development' ? 'hash' : 'history',
	// base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'IndexPage',
			component: IndexPage
		},
		{
			path: '/prereward',
			name: 'Prereward',
			component: loadView("./pages/home/Prereward02.vue")
		},
		{
			path: '/policy',
			name: 'policy',
			component: loadView("./views/policy.vue")
		},
		{
			path: '/privacy',
			name: 'privacy',
			component: loadView("./views/privacy.vue")
		},
		{
			path: '/camp01',
			name: 'Camp01',
			component: loadView("./pages/cv/Camp01.vue")
		},
		{
			path: '/camp02',
			name: 'Camp02',
			component: loadView("./pages/cv/Camp02.vue")
		},
		{
			path: '/camp03',
			name: 'Camp03',
			component: loadView("./pages/cv/Camp03.vue")
		},
		{
			path: '/camp04',
			name: 'Camp04',
			component: loadView("./pages/cv/Camp04.vue")
		},
		{
			path: '/camp05',
			name: 'Camp05',
			component: loadView("./pages/cv/Camp05.vue")
		},
		{
			path: '/camp06',
			name: 'Camp06',
			component: loadView("./pages/cv/Camp06.vue")
		},
		{
			path: '/camp07',
			name: 'Camp07',
			component: loadView("./pages/cv/Camp07.vue")
		}
	]
})
